import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import ThemeProvider from "./layouts/ThemeProvider"
import {ConfigProvider} from "antd"
import {Provider} from "react-redux"
import {store} from "./store"
import "moment-timezone"
import "moment/locale/ru"
import locale from "antd/locale/ru_RU"
import "assets/styles/globals.css"
import "assets/styles/font-face.css"
import {Auth0Provider} from "@auth0/auth0-react"
import {globalStyles} from "./layouts/Layout"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

if (!process.env.REACT_APP_AUTH_DOMAIN)
  throw new Error("Failed to find the REACT_APP_AUTH_DOMAIN")
if (!process.env.REACT_APP_AUTH_CLIENT_ID)
  throw new Error("Failed to find the REACT_APP_AUTH_CLIENT_ID")

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider locale={locale} theme={globalStyles}>
        <Auth0Provider
          domain={process.env.REACT_APP_AUTH_DOMAIN}
          clientId={process.env.REACT_APP_AUTH_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: process.env.REACT_APP_AUTH_AUDIENCE
          }}
        >
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </Auth0Provider>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
)
